module.exports = __webpack_public_path__ + "static/logo-9314635482cf678d1ab2f044372f3adc.png";